import React from "react";
import { Hand, Coffee, PartyPopper, Laugh, Music, Heart } from "lucide-react";
import { FONT, GLASS, glassBox } from "../kota/ui";
import { EMOTE_LABEL } from "../../lib/avatarDraw";

const IKON = { lambai: Hand, ngopi: Coffee, tepuk: PartyPopper, tertawa: Laugh, joget: Music, suka: Heart };
const WARNA = { lambai: "#d9a21b", ngopi: "#8a5a3c", tepuk: "#f97316", tertawa: "#2e9e5b", joget: "#0000CD", suka: "#e0245e" };
const URUT = ["lambai", "ngopi", "tepuk", "tertawa", "joget", "suka"];

// Menu emote melingkar di sekitar karakter sendiri (posisi layar `at` = [x, y] kaki karakter). Ketuk di luar untuk menutup.
export function EmoteRadial({ at, onPilih, onClose }) {
  const R = 86, cx = Math.min(window.innerWidth - R - 30, Math.max(R + 30, at[0])), cy = Math.min(window.innerHeight - R - 40, Math.max(R + 40, at[1] - 26));
  return (
    <div data-testid="emote-radial" onClick={onClose} style={{ position: "absolute", inset: 0, zIndex: 7, fontFamily: FONT }}>
      <style>{`@keyframes jw-pop{0%{transform:translate(-50%,-50%) scale(.4);opacity:0}100%{transform:translate(-50%,-50%) scale(1);opacity:1}}`}</style>
      {URUT.map((k, i) => {
        const a = -Math.PI / 2 + (i / URUT.length) * Math.PI * 2, Icon = IKON[k];
        return (
          <button key={k} data-testid={`emote-${k}`} aria-label={EMOTE_LABEL[k]} onClick={e => { e.stopPropagation(); onPilih(k); }}
            style={{ position: "absolute", left: cx + Math.cos(a) * R, top: cy + Math.sin(a) * R, transform: "translate(-50%,-50%)", animation: `jw-pop .22s ${i * 0.03}s cubic-bezier(.2,.9,.3,1.3) both`,
              display: "flex", flexDirection: "column", alignItems: "center", gap: 3, border: 0, background: "transparent", cursor: "pointer", padding: 0, WebkitTapHighlightColor: "transparent" }}>
            <span style={{ width: 50, height: 50, borderRadius: 99, ...glassBox, background: GLASS.bgStrong, display: "grid", placeItems: "center", color: WARNA[k] }}><Icon size={21} strokeWidth={2} /></span>
            <span style={{ fontSize: 10.5, fontWeight: 800, color: "#fff", textShadow: "0 1px 3px rgba(0,0,0,.6)" }}>{EMOTE_LABEL[k]}</span>
          </button>
        );
      })}
    </div>
  );
}
